import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId, VolunteerMentorSignup } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<VolunteerMentorSignup, unknown>[] = [
		buildColumn(util, 'Text', row => app.getTrimesterNameById(row.trimesterId), { header: 'Trimester' }),
		buildColumn(util, 'Text', row => row.volunteerSignupMentorStatus, { header: 'Status' }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.createdUTC, 'MMM D, YYYY', 'No Time', 'en-US'), { header: 'Signed-up Date' }),
		buildColumn(util, 'Text', row => row.selectedLanguage, { header: 'Selected Language' }),
		buildColumn(util, 'Text', row => row.assignedLanguageId === LanguageId.Espanol ? 'Spanish' : 'English', { header: 'Assigned Language' }),
	];

	return columns;

}